import "../styles/default.scss";

import autoBind from "auto-bind";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import withUserData from "../../../../../hocs/withUserData";
import Notifications from "../../../landingPage/pages/Notifications/components/notifications/Notifications";
import withNewNotifications from "../../../../../hocs/withNewNotifications";

@withNewNotifications
@withUserData
class NotificationIndicator extends Component {
  constructor(props: P, context: any) {
    super(props, context);
    autoBind.react(this);
  }

  onToggle() {
    const { setNotificationsOpen, notificationsOpen } = this.props;

    setNotificationsOpen({ open: !notificationsOpen });
  }

  render() {
    const { unreadCount, loading, notificationsOpen } = this.props;

    return (
      <div className="notification-indicator">
        <Dropdown isOpen={notificationsOpen} toggle={this.onToggle}>
          <DropdownToggle nav>
            {loading ? (
              <i className="fas fa-spinner fa-spin" />
            ) : unreadCount > 99 ? (
              "99+"
            ) : (
              String(unreadCount)
            )}
          </DropdownToggle>
          <DropdownMenu right>
            <Notifications {...this.props} onToggle={this.onToggle} />
          </DropdownMenu>
        </Dropdown>
        {notificationsOpen ? <div className="backdrop" /> : null}
      </div>
    );
  }
}

NotificationIndicator.propTypes = {
  unreadCount: PropTypes.number,
  messages: PropTypes.array
};

export default NotificationIndicator;
